import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import toUpperFirst from "ramda-extension/es/toUpperFirst";
import React from 'react';
import colorNames from '../../../utils/colorNames';
const SvgIcon = ({ className, children, viewBox, size, color, ...other })=>{
    return /*#__PURE__*/ React.createElement("svg", {
        className: cx('SvgIcon', {
            [`Color--${color}`]: color,
            [`SvgIcon--size${toUpperFirst(size || '')}`]: size
        }, className),
        viewBox: viewBox,
        ...other
    }, children);
};
SvgIcon.propTypes = {
    /**
	 * SVG path
	 */ children: PropTypes.node,
    /**
	 * Extra class name
	 */ className: PropTypes.string,
    /**
	 * One of theme color. If blank color will be applied.
	 */ color: PropTypes.oneOf(colorNames),
    /**
	 * Icon sizes
	 */ size: PropTypes.oneOf([
        'small',
        'large',
        'medium',
        'inherit'
    ]),
    /**
	 * view box of icon. It should be supplied from original svg.
	 */ viewBox: PropTypes.string
};
export default SvgIcon;
